module.exports = __webpack_public_path__ + "static/media/subOutlook1.5e7ffb1e.png";